import type { ConditionalFormattingScenario } from '../store/schema/ConditionalFormattingScenarioType';
import { getConditionalFormattingStore } from '../store/store';
import type { MailboxInfo } from 'owa-client-types';

export default function getKeyForRowIdInRowToModificationMap(
    rowId: string,
    mailboxInfo: MailboxInfo,
    scenario: ConditionalFormattingScenario
): string | null {
    const rowToModifications = getConditionalFormattingStore(
        mailboxInfo,
        scenario
    ).rowToModificationsMap;

    for (const key of rowToModifications.keys()) {
        if (key.indexOf(rowId) >= 0) {
            return key;
        }
    }

    return null;
}
